module.exports = __webpack_public_path__ + "media/images/common/ok_btn_l-ba2864bd3f210514477dd874c2d50d09.png";